import { render, staticRenderFns } from "./MusicwowDetails.vue?vue&type=template&id=685f36b8&scoped=true"
import script from "./MusicwowDetails.vue?vue&type=script&lang=js"
export * from "./MusicwowDetails.vue?vue&type=script&lang=js"
import style0 from "./MusicwowDetails.vue?vue&type=style&index=0&id=685f36b8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685f36b8",
  null
  
)

export default component.exports